/*
 * Copyright (c) 2020.
 * Ducnq
 */

import {REPORT_API_USE_SUCCESS} from "../../types";

/**
 * @param {*} state
 * @param {*} action
 */
const ActivityLogsReducer = (state = {}, action) => {
    if (action.payload === undefined || action.payload === false) return state;

    switch (action.type) {
        case REPORT_API_USE_SUCCESS:
            return {...state, action};
        default:
            return state;
    }
};

export {ActivityLogsReducer}